import {
    GET_PBSS_REQUEST,
    GET_PBSS_SUCCESS,
    GET_PBSS_FAILURE,
} from "./constants";

export interface IState {
    startDate: Date;
    stopDate: Date;
    gotData: boolean;
    loading: boolean;
    error: null | string;
    data: any;
}

export const initialState: any = {
    gotData: false,
    loading: false,
    error: null,
    startDate: new Date(),
    stopDate: new Date(),
    scoreData: [],
};

export const PBSSReducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case GET_PBSS_REQUEST:
            return {
                ...state,
                gotData: false,
                loading: true,
                error: null,
            };
        case GET_PBSS_SUCCESS:

            const newState = {
                ...state,
                loading: false,
                gotData: true,
                scoreData: action.payload.scoreData,
            };

            return newState;

        case GET_PBSS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
